
import { useState, useRef, useEffect } from "react"
import {
  Button,
  Col,
  Dropdown,
  Form,
  Row,
  Modal,
  Nav,
  Table,
  Accordion,
} from "react-bootstrap"
import {
  faCalendar,
  faCancel,
  faClone,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faIndianRupeeSign,
  faPaperclip,
  faPrint,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"

import { useLocation, useParams } from "react-router-dom"

import { toast } from "sonner"
import { baseURL, imageURL } from "../../Utils/constants/constant"
import {
  downloadPdf,
  formatDate,
  formatToINR,
  maskContactNumber,
  navigateBackFromCrmDetail,
  navigateToCrmDetail,
  printPdf,
  TextWithLineBreaks,
} from "../../Utils/helpers/commonhelper"

import DeleteModal from "../DeleteModal"
import { DetailsQuotationSkeletonLoader } from "../../Utils/skeletonLoader/DetailsQuotationSkeletonLoader"

import { CreateSalesOrder } from "../SalesOrder/CreateSalesOrder"
import { SalesOrderDetailsOffcanvas } from "../SalesOrder/SalesOrderDetailsOffcanvas"
import { UpgradePlan } from "../../CommonComponents/UpgradePlan"
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"
import Spinner from "../../Utils/helpers/SpinLoader"

const isHtmlContent = (val) => /<\/?[a-z][\s\S]*?>/i.test(val || "");


const RICH_TEXT_BOX_HEIGHT = 150; 

const richTextViewCss = `
.quotation-rich-text ol,
.quotation-rich-text ul {
  margin: 0;
  padding-left: 1.4rem;
}
.quotation-rich-text p {
  margin: 0 0 0.5rem;
}
.quotation-rich-text p:last-child {
  margin-bottom: 0;
}
/* Same box style everywhere: fixed height, border, content scrolls inside instead of growing the box */
.quotation-rich-text-box {
  height: ${RICH_TEXT_BOX_HEIGHT}px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #add8e6;
  border-radius: 4px;
  padding: 10px 12px;
  box-sizing: border-box;
}
`;

const RichTextView = ({ value, className, style, emptyText }) => {
  const cls = `quotation-rich-text quotation-rich-text-box${className ? ` ${className}` : ""}`;
  if (!value) {
    return emptyText ? (
      <>
        <style>{richTextViewCss}</style>
        <div className={cls} style={style}>
          {emptyText}
        </div>
      </>
    ) : null;
  }
  if (isHtmlContent(value)) {
    return (
      <>
        <style>{richTextViewCss}</style>
        <div
          className={cls}
          style={style}
          dangerouslySetInnerHTML={{ __html: value }}
        />
      </>
    );
  }
  return (
    <>
      <style>{richTextViewCss}</style>
      <div className={cls} style={style}>
        {TextWithLineBreaks(value)}
      </div>
    </>
  );
};

export const DetailsQuotation = () => {

  // getting essentials for apis
  const { customer, setCustomer, headers, extras, navigate, customerId: customer_id, loginUserId, userType } = useGetEssentials()

  // rbac permission object
  const [PERMISSION, _] = useLocalStorageState('permission')

  const location = useLocation()
  const { paramId } = useParams()
  const [quoteId, setQuoteId] = useState()
  const [quoteData, setQuoteData] = useState([])
  const [billingAdressData, setBilllingAdress] = useState([])
  const [shipingAdressData, setshipingAdress] = useState([])
  const [items, setItem] = useState([])
  const [departmentToDelete, setDepartmentToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showModalD, setShowModalD] = useState(false)
  const [modalType, setModalType] = useState(null) // 'approve' or 'reject'
  const [rejectReason, setRejectReason] = useState("")
  const [loading, setLoading] = useState(false)
  const [showCreateSalesOrder, setShowCreateSalesOrder] = useState(false)
  const [toCancelQuotation, setToCancelQuotation] = useState()
  const [salesOrderDetailsOffcanvas, setSalesOrderDetailsOffcanvas] = useState(false)
  // sale order details offcanvas
  const [editData, setEditData] = useState(null)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const [isClone, setIsClone] = useState(false)
  const [salesOrderId, setsalesOrderId] = useState()

  const [openDescriptions, setOpenDescriptions] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const handleOpenModal = (type) => {
    setModalType(type)
    setShowModal(true)
  }

  // QUOTATION PERMISSION
  const isQuotation = PERMISSION.quotation.isAuthorized;
  const quotationGrant = PERMISSION.quotation;
  const contactGrant = PERMISSION.contact
  const dealGrant = PERMISSION.deals;
  const companyGrant = PERMISSION.company;
  const salesGrant = PERMISSION.sales_order;

  const handleSalesOrderDetails = async (id) => {
    if (!id) return
    try {
      const res = await GetRequest(
        `/sales/fetchDetailsOfSpecificOrder/${id}/${customer_id}/${loginUserId}`,
        { headers },
        extras
      )
      if (res.status === "success") {
        const editDataToSet = res.data
        setEditData(editDataToSet[0])
        setSalesOrderDetailsOffcanvas(true)

        setIsClone(false)
        setsalesOrderId(id)
      }
    } catch (error) {
      console.error(error)
    }
  }


  const handleNavigateToDeal = async () => {
    if (!quoteData?.deal_id) {
      return
    }
    if (!dealGrant.isView) {
      toast.warning("You are not authorized for this action!")
      return
    }

    let pipelineId =
      quoteData.pipeline_id ??
      quoteData.deal_pipeline_id ??
      null

    if (pipelineId == null) {
      try {
        const res = await GetRequest(
          `deals/getDealDetails/${quoteData.deal_id}/${customer_id}/${loginUserId}`,
          { headers },
          extras,
        )
        if (res?.status !== "fail" && res?.success !== false && res?.data) {
          pipelineId = res.data.pipeline_id ?? null
        }
      } catch (error) {
        console.error(error)
      }
    }

    navigateToCrmDetail(navigate, location, "/dealDetails", {
      id: quoteData.deal_id,
      pipeline_id: pipelineId,
    })
  }

  const handleCloseQuotationDetails = () => {
    navigateBackFromCrmDetail(navigate, location, "/quotations")
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setRejectReason("")
    navigate("/quotations")
  }
  const handleConfir = async () => {
    setLoading(true)
    try {
      const payload = {
        quotation_id: toCancelQuotation,
        customer_id: customer_id,
        canceletion_reason: rejectReason,
        user_login_id: loginUserId,
      }
      const res = await PutRequest(
        `quotation/cancelQuotation`,
        payload,
        { headers },
        extras
      )

      if (!res || res.status === "fail") {
        return toast.error(res.message || "something went wrong")
      }
      if (res.status === "success") {
        toast.success(res.message)
        setToCancelQuotation()
        setRejectReason("")
        navigate("/quotations")

        setShowModalD(false)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setShowModalD(false)
      setLoading(false)
    }
  }

  const handleConfirm = async () => {
    setLoading(true)
    try {
      let payload
      if (modalType === "reject") {
        payload = {
          reject_reason: rejectReason,
          quotation_id: quoteId,
          quotation_status: modalType,
        }
      } else {
        payload = {
          reject_reason: "",
          quotation_id: quoteId,
          quotation_status: "approved",
          user_login_id: loginUserId,
        }
      }
      const res = await PutRequest(
        `quotation/changeQuotationStatus`,
        payload,
        { headers },
        extras
      )

      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message)
      }
      if (res.status === "success") {
        toast.success(res.message)
        return navigate("/quotations")
      }
    } catch (error) {
      console.error(error, "something went wrong ")
    } finally {
      handleCloseModal()
      setLoading(false)
    }
  }

  const fetchQuotationDetailsById = async () => {
    if (!paramId) {
      return
    }

    setQuoteId(paramId)
    setIsLoading(true)

    try {
      const res = await GetRequest(
        `quotation/fetchDataOfSpecificQuotation/${paramId}/${customer_id}/${loginUserId}`,
        { headers },
        extras
      )

      if (res.status === "success") {
        setQuoteData(res.data[0])

        if (res?.data[0]?.billing_address && res?.data[0]?.shipping_address) {
          const bill_address = JSON.parse(
            res?.data[0]?.billing_address || "[]",
          );
          const ship_address = JSON.parse(
            res?.data[0]?.shipping_address || "[]",
          );
          setBilllingAdress(bill_address);
          setshipingAdress(ship_address);
        } else {
          const addresses = JSON.parse(
            res?.data[0]?.company_billing_address || "[]",
          );

          let billingAddress = addresses.find(
            (add) => add.selected === "selected",
          );

          if (!billingAddress) {
            billingAddress = addresses.find((add) => add.for === "shipping");
          }

          if (!billingAddress) {
            billingAddress =
              addresses[0] || JSON.parse(res?.data[0]?.billing_address || "{}");
          }

          const shippingAddress =
            addresses.find((add) => add.for === "shipping") || billingAddress;

          setBilllingAdress(billingAddress);
          setshipingAdress(shippingAddress);
        }

        const itemsArray = JSON.parse(res.data[0]?.items)

        const parsedData = itemsArray.flatMap((entry) => {
          const gstInfo = (entry.gstBreakdown || []).map((gstItem) => ({
            gstRate: gstItem.gst ?? 0,
            gstAmount: gstItem.amount ?? 0,
          }))

          return entry.itemDetails.map((detail) => ({
            productName: detail.name,
            productQuantity: detail.quantity ?? 0,
            productRate: detail.Rate ?? 0,
            productGst: detail.gst ?? 0,
            productDiscount: detail.discount ?? 0,
            productAmount: detail.amount ?? 0,
            productDiscountAmount: detail.discountedAmount ?? 0,
            productDiscountType: detail.discountType ?? 0,
            subTotal: entry["sub-total"] ?? 0,
            specialDiscount: entry["special-discount"] ?? 0,
            grandTotal: entry["grand-total"] ?? 0,
            shippingCharge: entry["shipping_Charge"] ?? 0,
            specialDiscountAmount: entry["special_Discount_Amount"] ?? 0,
            specialDiscountType: entry["special_DiscountType"] ?? 0,
            gstBreakdown: gstInfo,
            productDescription: detail?.itemDescription
          }))
        })

        setItem(parsedData)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    fetchQuotationDetailsById()
  }, [paramId])

  const [rows, setRows] = useState([{ selected: "Percentage", isOpen: false }])

  const dropdownRefs = useRef([])

  useEffect(() => {
    const handleClickOutside = (event) => {
      dropdownRefs.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target)) {
          setRows((prev) =>
            prev.map((row, i) =>
              i === index ? { ...row, isOpen: false } : row
            )
          )
        }
      })
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  // Trigger delete modal
  const onDelete = (id) => {
    setDepartmentToDelete(id)
    setShowDeleteModal(true)
  }
  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `quotation/deleteQuotation/${departmentToDelete}/${loginUserId}/${customer_id}`,
        { headers },
        extras
      )

      if (res?.status === "success") {
        toast.success(res.message)
        navigate("/quotations")
      } else if (res.status === "fail") {
        toast.error(res.message)
      }
    } catch (error) {
      console.error("Delete error:", error)
    } finally {
      setLoading(false)
      setShowDeleteModal(false)
      setDepartmentToDelete(null)
    }
  }

  const handleCancelQuotatio = (quotation) => {
    if (!quotation) return

    setToCancelQuotation(quotation.quotation_id)

    setShowModalD(true)
  }

  const handleCloseModa = () => {
    setShowModal(false)
    setRejectReason("")
  }

  const handleSendQuotation = async (id) => {
    if (!id) return
    setLoading(true)

    try {
      const payload = {
        quotation_id: id,
        customer_id: customer_id,
        user_login_id: loginUserId,
      }

      const res = await PostRequest(
        `/quotation/sendQuotation`,
        payload,
        false,
        { headers },
        extras
      )

      if (res.status !== "success" || res.status === "fail") {
        return toast.error(res.message)
      }
      toast.success(res.message)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  const handleCreateSalesOrderClose = () => {
    setShowCreateSalesOrder(false)
  }

  if (showCreateSalesOrder) {
    if (quoteData?.contact_id) {
      return (
        <CreateSalesOrder
          contact_id={quoteData?.contact_id}
          deal_id={quoteData?.deal_id}
          quotation_id={quoteData?.quotation_id}
          onClose={handleCreateSalesOrderClose}
        />
      )
    }
  }

  if (isLoading) {
    return <DetailsQuotationSkeletonLoader />
  }
  const toggleDescription = (index) => {
    setOpenDescriptions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }


  if (!isQuotation) {
    return <UpgradePlan moduleName="Quotation" />
  }

  if (!quotationGrant.isView) {
    return <AuthorizationCard />
  }

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      />

      {loading && 
      <Spinner text="Processing..." />
      }

      <div
        style={{
          borderRadius: 7,
          background: "#fff",
          height: "calc(100vh - 12vh)",
          border: "1px solid lightblue",
          overflow: "clip",
        }}
      >
        <div
          className="header mb-0 position-sticky top-0 p-3"
          style={{
            borderBottom: "1px solid lightblue",
            zIndex: 11,
            background: "#fff",
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <h3
              className="mb-0"
              style={{
                whiteSpace: "nowrap",
                fontWeight: 300,
                fontSize: "22px",
              }}
            >
              Quotation Details -
              <span style={{ color: "#0099ff" }}>
                #{quoteData.quotation_number}
              </span>
            </h3>

            <div className="d-flex align-items-center">
              <div className="me-2">
                <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <button
                      className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                      style={{
                        fontSize: "1rem",
                        alignItems: "center",
                        height: "39px",
                      }}
                    >
                      Pdf/Print
                    </button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdown dropdown-menu-end"
                    style={{
                      width: "11rem",
                      padding: "12px 0px",
                      right: "3.4rem",
                    }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        printPdf(
                          `${baseURL}/quotation/downloadQuotation/${customer_id}/${quoteId}`,
                          headers,
                          "print", `${loginUserId}`,setLoading
                        )
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPrint}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      Print
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        downloadPdf(
                          `${baseURL}/quotation/downloadQuotation/${customer_id}/${quoteId}`,
                          headers,
                          "download",
                          "quotation", `${loginUserId}`,setLoading
                        )
                      }}
                      className="d-flex align-items-center"
                    >
                      <FontAwesomeIcon
                        icon={faDownload}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      Download
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {location?.state?.key2 ? (
                ""
              ) : (
                <>
                  {quoteData.quotation_status === "approved" && (
                    <button
                      className="btn btn-default-outline me-2"
                      type="button"
                      onClick={() =>
                        quoteData.quotation_status === "approved" &&
                        handleSendQuotation(quoteData.quotation_id)
                      }
                      aria-expanded="false"
                      style={{ height: "39px" }}
                    >
                      Send
                    </button>
                  )}

                  <div>
                    <Dropdown as="div" className="dropdownsWithoutToggle">
                      <Dropdown.Toggle as={Nav.Link} className="header-link">
                        <button
                          className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                          style={{
                            fontSize: "1rem",
                            alignItems: "center",
                            height: "39px",
                            width: "2.5rem",
                          }}
                        >
                          <FontAwesomeIcon
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                            icon={faEllipsisVertical}
                          />
                        </button>
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        className="defaultDropdown dropdown-menu-end"
                        style={{
                          width: "11rem",
                          padding: "12px 0px",
                          right: "3.4rem",
                        }}
                      >
                        {quoteData.quotation_status === "approved" ? (
                          ""
                        ) : (
                          <>
                            <Dropdown.Item
                              href="#"
                              className="d-flex align-items-center"
                              onClick={() =>
                                navigate(
                                  `/editquotation/${quoteData?.quotation_id}`,
                                  {
                                    state: { mode: "edit", from: "detailPage" },
                                  }
                                )
                              }
                            >
                              <FontAwesomeIcon
                                icon={faEdit}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  marginRight: "9px",
                                  color: "#5e5f60",
                                }}
                              />
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              href="#"
                              className="d-flex align-items-center"
                              onClick={() =>
                                navigate(
                                  `/editquotation/${quoteData?.quotation_id}`,
                                  {
                                    state: {
                                      mode: "clone",
                                      from: "detailPage",
                                    },
                                  }
                                )
                              }
                            >
                              <FontAwesomeIcon
                                icon={faClone}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  marginRight: "9px",
                                  color: "#5e5f60",
                                }}
                              />
                              Revised
                            </Dropdown.Item>
                          </>
                        )}
                        <Dropdown.Item
                          href="#"
                          className="d-flex align-items-center"
                          onClick={() =>
                            quoteData.quotation_status === "approved"
                              ? handleCancelQuotatio(quoteData)
                              : onDelete(quoteData.quotation_id)
                          }
                        >
                          <FontAwesomeIcon
                            icon={
                              quoteData.quotation_status === "approved"
                                ? faCancel
                                : faTrash
                            }
                            style={{
                              width: "16px",
                              height: "16px",
                              marginRight: "9px",
                              color: "#5e5f60",
                            }}
                          />
                          {quoteData.quotation_status === "approved"
                            ? "Cancel"
                            : "Delete"}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            if (!salesGrant.isCreate) {
                              toast.warning("You are not authorized for this action!")
                              return
                            }
                            navigate("/createSalesOrder", {
                              state: {
                                contact_id: quoteData?.contact_id,
                                deal_id: quoteData.deal_id,
                                quotation_id: quoteData.quotation_id,
                              },
                            })
                          }}
                          className="fs-13 d-flex gap-2 align-items-center"
                        >
                          <FontAwesomeIcon icon={faCalendar} /> Sales Order
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </>
              )}

              {/* Close Button */}
              <button
                className="btn btn-default ms-2"
                aria-label="Go Back"
                type="button"
                onClick={handleCloseQuotationDetails}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>
        </div>

        <div
          className="form-container"
          style={{
            margin: 0,
            overflowY: "auto",
            height: "100%",
            paddingLeft: "0px",
            paddingTop: "12px",
            position: "relative",
          }}
        >
          {/* <Col md={12} className="px-0"></Col> */}
          <Row className="ms-0 w-100 mb-0">
            <Col md={2} style={{ borderRight: "1px solid #d4e7ed" }}>
              <div style={{ position: "sticky", top: "1rem" }} className="mt-3">
                <ul className=" ps-3" style={{ listStyle: "none" }}>
                  <li className="position-relative border-start ps-3 py-2 pt-0 ps-4">
                    <span
                      className="position-absolute  start-0 translate-middle bg-primary rounded-circle"
                      style={{
                        width: 10,
                        height: 10,
                        top: 11,
                        border: "1px solid #0099ff",
                      }}
                    ></span>
                    <a
                      href="#companyDetailsSection"
                      style={{ color: "#676262" }}
                    >
                      Quotation
                    </a>
                  </li>

                  <li className="position-relative border-start ps-3 py-2 ps-4">
                    <span
                      className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                      style={{ width: 10, height: 10 }}
                    ></span>
                    <a href="#itemsDetailsSection" style={{ color: "#676262" }}>
                      Items Details
                    </a>
                  </li>
                  <li className="position-relative border-start ps-3 py-2 ps-4">
                    <span
                      className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                      style={{ width: 10, height: 10 }}
                    ></span>
                    <a
                      href="#termsAndConditionsSec"
                      style={{ color: "#676262" }}
                    >
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
                <hr />
              </div>
            </Col>

            <Col md={10} className="ps-3">
              <div className="ms-0 w-100" id="companyDetailsSection">
                {/* <Row className="ms-0 w-100" style={{ paddingRight: 4 }}> */}
                <div
                  className="ms-0 w-100 p-3"
                  style={{ backgroundColor: "#fbfcff", borderRadius: 4 }}
                >
                  <Row className="pt-3 px-1">
                    <Col md={6}>
                      {" "}
                      <h3
                        // className="mb-4 pt-3"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          color: "#313131ff",
                        }}
                      >
                        Quotation
                      </h3>
                    </Col>
                    <Col md={6}>
                      {" "}
                      <div className="d-flex align-items-end justify-content-end">
                        <span className="font-small">
                          <span style={{ fontWeight: 200 }}>
                            Quotation Number{" "}
                          </span>
                          <strong className="font-small">#{quoteData.quotation_number}</strong>
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  {/* ROW 1: ADDRESSES (Billing Left, Shipping Right)           */}

                  <Row className="mb-4">
                    {/* Billing Address */}
                    <Col md={6}>
                      <h3
                        className="mb-3"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          color: "#0099ff",
                        }}
                      >
                        Billing Address
                      </h3>
                      <div
                        className="fs-13 text-dark"
                        style={{ fontWeight: 300 }}
                      >
                        <span
                          className="d-block mb-0"
                          style={{ fontWeight: 600 }}
                        >
                          {quoteData.company_name}
                        </span>
                        {billingAdressData.address}
                        <p
                          className="mt-0 mb-0"
                          style={{ fontWeight: 300, fontSize: 13 }}
                        >
                          {(typeof billingAdressData?.city === "object"
                            ? billingAdressData?.city?.label || billingAdressData?.city?.value
                            : billingAdressData?.city)}
                          ,{" "}
                          {(typeof billingAdressData?.state === "object"
                            ? billingAdressData?.state?.label || billingAdressData?.state?.value
                            : billingAdressData?.state)}
                          ,{" "}
                          {(typeof billingAdressData?.country === "object"
                            ? billingAdressData?.country?.label || billingAdressData?.country?.value
                            : billingAdressData?.country)}
                          - {billingAdressData?.zipcode}
                        </p>
                      </div>
                    </Col>

                    {/* Shipping Address */}
                    <Col md={6}>
                      <h3
                        className="mb-3 ps-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          color: "#0099ff",
                        }}
                      >
                        Shipping Address
                      </h3>
                      <div
                        className="fs-13 text-dark ps-2"
                        style={{ fontWeight: 300 }}
                      >
                        <span
                          className="d-block mb-0"
                          style={{ fontWeight: 600 }}
                        >
                          {quoteData.company_name}
                        </span>
                        {shipingAdressData.address}
                        <p
                          className="mt-0 mb-0"
                          style={{ fontWeight: 300, fontSize: 13 }}
                        >
                          {(typeof shipingAdressData?.city === "object"
                            ? shipingAdressData?.city?.label || shipingAdressData?.city?.value
                            : shipingAdressData?.city)
                            ? (typeof shipingAdressData?.city === "object"
                              ? shipingAdressData?.city?.label || shipingAdressData?.city?.value
                              : shipingAdressData?.city) + ","
                            : ""}{" "}

                          {(typeof shipingAdressData?.state === "object"
                            ? shipingAdressData?.state?.label || shipingAdressData?.state?.value
                            : shipingAdressData?.state)
                            ? (typeof shipingAdressData?.state === "object"
                              ? shipingAdressData?.state?.label || shipingAdressData?.state?.value
                              : shipingAdressData?.state) + ","
                            : ""}{" "}

                          {typeof shipingAdressData?.country === "object"
                            ? shipingAdressData?.country?.label || shipingAdressData?.country?.value
                            : shipingAdressData?.country}{" "}
                          - {shipingAdressData?.zipcode}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <hr className="my-4" />

                  {/* --------------------------------------------------------- */}
                  {/* ROW 2: DETAILS (Left) & STATUS/DESC (Right)               */}
                  {/* --------------------------------------------------------- */}
                  <Row>
                    <h3
                      className="mb-3"
                      style={{
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Quote Details
                    </h3>
                    {/* LEFT SIDE: Contact & General Details */}
                    <Col md={6} className=" pe-4">
                      {/* Quotation Number */}
                      {/* <div className="d-flex align-items-center mb-2">
                      <span
                        className="text-secondary fw-medium"
                        style={{ minWidth: "130px", fontSize: "14px" }}
                      >
                        Quotation Number
                      </span>
                      <span className="fw-semibold">
                        #{quoteData.quotation_number}
                      </span>
                    </div> */}

                      {/* Contact Name */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Contact
                        </span>
                        <span
                          className="text-primary cursor-pointer fs-13"
                          style={{ cursor: "pointer", fontWeight: 500 }}
                          onClick={() => {
                            if (!contactGrant.isView) {
                              toast.warning("You are not authorized for this permission!")
                              return
                            }
                            if (!quoteData?.contact_id) {
                              return
                            }
                            navigateToCrmDetail(
                              navigate,
                              location,
                              `/contactDetails?currContactId=${quoteData.contact_id}`,
                            )
                          }}
                        >
                          : {quoteData.contact_full_name}
                        </span>
                      </div>

                      {/* Company Name */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Company Name
                        </span>
                        <span
                          className="text-primary  cursor-pointer fs-13"
                          style={{
                            cursor: quoteData.company_name ? "pointer" : "default",
                            fontWeight: 500,
                          }}
                          onClick={() => {
                            if (!quoteData?.company_id) {
                              return
                            }
                            if (!companyGrant.isView) {
                              toast.warning("You are not authorized for this action!")
                              return
                            }
                            navigateToCrmDetail(
                              navigate,
                              location,
                              `/companyDetails?currCompanyId=${quoteData.company_id}`,
                            )
                          }}
                        >
                          : {quoteData.company_name || "-"}
                        </span>
                      </div>
                      {/* Reference */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Reference
                        </span>
                        <span className="fs-13" style={{ fontWeight: 500 }}>
                          {" "}
                          : {quoteData.reference_number}
                        </span>
                      </div>

                      {/* Approved By */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Approved By
                        </span>
                        <span
                          className="fs-13"
                          style={{ textTransform: "capitalize", fontWeight: 500 }}
                        >
                          : {quoteData.approver_name}
                        </span>
                      </div>

                      {/* Quote Date */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Current Status
                        </span>
                        <span
                          className={`fs-13 ${quoteData.quotation_status === "approved"
                            ? "text-success"
                            : quoteData.quotation_status === "rejected"
                              ? "text-danger"
                              : "text-warning"
                            }`}
                          style={{
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            fontWeight: 500,
                          }}
                        >
                          : {quoteData.quotation_status || "Draft"}
                        </span>
                      </div>
                    </Col>

                    {/* RIGHT SIDE: Status (Top) & Description (Bottom) */}
                    <Col md={6} className=" ps-4">
                      {/* UPPER PART: Status */}

                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Quote Date
                        </span>
                        <span className="fs-13" style={{ fontWeight: 500 }}>
                          {" "}
                          : {formatDate(quoteData.quotation_date)}
                        </span>
                      </div>

                      {/* Expiry Date */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Expiry Date
                        </span>
                        <span className="fs-13" style={{ fontWeight: 500 }}>
                          {" "}
                          : {formatDate(quoteData.expiry_date)}
                        </span>
                      </div>

                      {/* Lead Owner */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Lead Owner
                        </span>
                        <span
                          className="fs-13"
                          style={{ textTransform: "capitalize", fontWeight: 500 }}
                        >
                          : {quoteData.owner_name}
                        </span>
                      </div>

                      {/* Deal */}
                      <div className="d-flex align-items-center mb-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Deal
                        </span>
                        <span
                          className="text-primary fs-13"
                          style={{
                            textTransform: "capitalize",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                          onClick={() => {
                            handleNavigateToDeal()
                          }}
                        >
                          : {quoteData.deal_name}
                        </span>
                      </div>
                      {/* LOWER PART: Description */}
                      <div className="flex-grow-1">
                        <span
                          className="text-secondary fw-300"
                          style={{
                            minWidth: "130px",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          Short Description (Subject)
                        </span>
                        <div
                          className="text-break fs-13"
                          style={{ fontWeight: 500 }}
                        >
                          {quoteData?.description || (
                            <span className="text-muted fst-italic">
                              No description provided.
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    paddingRight: 4,
                    marginBottom: "2rem",
                    marginTop: "2rem",
                  }}
                >
                  <Col md={12} className="pe-0 ps-0">
                    <Accordion
                      defaultActiveKey="null"
                      className="sales-order-accordion shadow-none border-0 focus-ring-0 w-100"
                    >
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="shadow-none border-0 focus-ring-0 bg-transparent">
                          Sales order details
                        </Accordion.Header>

                        <Accordion.Body className="p-0">
                          <div
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                          >
                            <Table className="table-sticky">
                              <thead>
                                <tr>
                                  <th>Sales Order</th>
                                  <th>Owner Name</th>
                                  <th>Order Status</th>
                                  <th>Sales Order Date</th>
                                  <th>Shipment Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {quoteData?.sales_order?.length > 0 ? (
                                  quoteData?.sales_order?.map(
                                    (quote, index) => (
                                      <tr key={index}>
                                        <td
                                          className="text-primary"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleSalesOrderDetails(quote.id)
                                          }
                                        >
                                          {quote.sale_no || "-"}
                                        </td>
                                        <td>{quote.owner_name || "-"}</td>
                                        <td>{quote.order_status || "-"}</td>
                                        <td>
                                          {formatDate(quote.sales_order_date) ||
                                            "-"}
                                        </td>
                                        <td>
                                          {formatDate(quote.shipment_date) ||
                                            "-"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={5}> No Data Found</td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>

                <Row
                  id="itemsDetailsSection"
                  style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
                >
                  <h3
                    className="ps-0 mb-3"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 300,
                      fontSize: "19px",
                      color: "#0099ff",
                    }}
                  >
                    Items Details
                  </h3>

                  <Col md={12} className="pe-0 ps-0">
                    <div className="table-responsive quatationsTables mb-3 ">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th className="text-start">Items Name</th>
                            <th style={{ width: "10%" }} className="text-end">
                              Quantity
                            </th>
                            <th style={{ width: "11%" }} className="text-end">
                              Rate
                            </th>
                            <th style={{ width: "11%" }} className="text-end">
                              GST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th style={{ width: "16%" }} className="text-end">
                              Discount(
                              <i className="bi bi-percent"></i>/
                              <i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th
                              style={{ width: "11%" }}
                              className="text-center pe-2"
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <>
                              <tr key={index}>
                                <td className="text-start">
                                  <div>
                                    <p
                                      className="w-100 mb-0 d-flex fs-15 align-items-center justify-content-between"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {item.productName}
                                    </p>
                                    <p
                                      className="mb-0"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {/* {item.productDiscription || ""} */}
                                      {item.productDescription && (
                                        <div
                                          className="mt-1 d-flex align-items-left"
                                          style={{ cursor: "pointer", color: "#0099ff", fontSize: "12px" }}
                                          onClick={() => toggleDescription(index)}
                                        >
                                          <i
                                            className={`me-1 ${openDescriptions[index] ? "bi bi-x" : "bi bi-plus"
                                              }`}
                                          ></i>
                                          {openDescriptions[index] ? "hide item description" : "show item description"}

                                        </div>
                                      )}
                                    </p>
                                  </div>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-2 pt-0"
                                  >
                                    {item?.productQuantity ? `${item?.productQuantity} pcs` : "-"}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-2 pt-0"
                                  >
                                    {formatToINR(item.productRate)}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-3 pt-0"
                                  >
                                    {item.productGst}
                                    <i className="bi bi-percent"></i>
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-3 pt-0"
                                  >
                                    {item.productDiscount}
                                    {item.productDiscountType === "Percentage" ? (
                                      <i className="bi bi-percent"></i>
                                    ) : (
                                      <i className="ti ti-currency-rupee"></i>
                                    )}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <div className="d-flex gap-2 align-items-center justify-content-end">
                                    <div
                                      className="fs-14 text-end"
                                      style={{ fontWeight: 500, fontSize: 14, paddingRight: "7px", }}
                                    >
                                      {formatToINR(item.productDiscountAmount)}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              {openDescriptions[index] && item.productDescription && (
                                <tr>
                                  <td colSpan={6} className="p-0 border-0">
                                    <div className="px-1 py-2">
                                      <RichTextView
                                        value={item.productDescription}
                                        className="normalTextarea"
                                        style={{
                                          background: "#f9f9fb",
                                          cursor: "default",
                                          whiteSpace: "pre-wrap",
                                          textAlign: "left"
                                        }}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </>
                          ))}

                          <tr>
                            <th
                              className="text-start bg-transparent border-0 vertical-top w-100"
                              style={{ verticalAlign: "top" }}
                            >
                              <div className="mt-1">
                                <p
                                  className="ps-1 mb-2 fs-14"
                                  style={{ fontWeight: 400 }}
                                >
                                  Customer Note
                                </p>
                                <RichTextView
                                  value={quoteData.customer_note}
                                  className="ps-1 text-wrap fs-13 fw-normal"
                                />
                              </div>
                            </th>
                            <th
                              colSpan={5}
                              className="text-start bg-transparent border-0 "
                            >
                              <div
                                className=" w-100 h-100 "
                                style={{
                                  borderRadius: 5,
                                  background: "#f9f9fb",
                                  padding: "1rem 0.6rem",
                                }}
                              >
                                <div className="row sub-total mb-2 text-semibold ">
                                  <div className="total-label col-md-6 fw-500 d-flex align-items-center fs-14">
                                    Sub Total
                                  </div>
                                  <div className="total-amount fs-14 fw-500 text-end text-semibold col-md-6 d-flex align-items-center gap-1 justify-content-end">
                                    {formatToINR(items[0]?.subTotal)}
                                  </div>
                                </div>

                                <div className="row sub-total mb-1">
                                  <div className="total-label col-md-4 d-flex text-secondary align-items-center  fs-13">
                                    Special Discount
                                    <span className="ps-1 text-secondary fw-400 fs-13">
                                      ({items[0]?.specialDiscount}
                                      <span className="pe-1 ">
                                        <i>{items[0]?.specialDiscountType}</i>
                                      </span>
                                      )
                                    </span>
                                  </div>

                                  <div className="total-amount text-end fs-13 text-secondary fw-400 text-semibold col-md-8 d-flex align-items-center justify-content-end">
                                    -{" "}
                                    {formatToINR(items[0]?.specialDiscountAmount)}
                                  </div>
                                </div>

                                <div className="row sub-total mb-1">
                                  <div className="total-label col-md-4 d-flex align-items-center fs-13 text-secondary fw-400">
                                    Shipping Charge
                                  </div>
                                  <div className="total-amount text-end text-semibold fs-13 text-secondary fw-400 col-md-8 d-flex align-items-center gap-1 justify-content-end">
                                    {formatToINR(items[0]?.shippingCharge)}
                                  </div>
                                </div>

                                <div>
                                  {[
                                    ...new Map(
                                      items
                                        .flatMap((item) => item.gstBreakdown)
                                        .map((gst) => [gst.gstRate, gst])
                                    ).values(),
                                  ].map((gst) => (
                                    <div
                                      className="row sub-total mb-2"
                                      key={gst.gstRate}
                                    >
                                      <div className="total-label col-md-4  d-flex align-items-center fs-13 text-secondary fw-400">
                                        GST
                                        <span className="ps-1 fs-13 text-secondary fw-400">
                                          ({gst.gstRate}%)
                                        </span>
                                      </div>
                                      <div className="total-amount text-end fs-13 text-secondary fw-400 col-md-8  d-flex align-items-center justify-content-end gap-1">
                                        {formatToINR(
                                          Number(`${gst.gstAmount}`).toFixed(2)
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                <hr />
                                <div className="row sub-total text-semibold ">
                                  <div className="total-label fw-500 fs-14 col-md-6">
                                    Grand Total
                                  </div>
                                  <div className="total-amount text-end fs-14 fw-500 col-md-6">
                                    {formatToINR(items[0]?.grandTotal)}
                                  </div>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>

                <Row id="termsAndConditionsSec" className="mt-3">
                  <Col md={8}>
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Terms & Conditions
                    </h3>

                    <Form.Group className="mb-3" controlId="formTerms">
                      <RichTextView
                        value={quoteData.terms_condition}
                        className="ps-1 mb-2 fs-13"
                        style={{ fontWeight: 400 }}
                        emptyText="Terms and conditions not available"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className="mb-3">
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#0099ff",
                      }}
                    >
                      Attachment
                    </h3>
                    <div
                      style={{
                        borderRadius: "10px",
                        padding: "10px 0px",
                        textAlign: "start",
                        width: "100%",
                        maxWidth: "400px",
                        margin: "0px",
                      }}
                    >
                      <p
                        style={{ marginBottom: "5px", color: "#666" }}
                        className="d-flex align-items-center"
                      >
                        <FontAwesomeIcon
                          icon={faPaperclip}
                          className="me-2 fs-20"
                          style={{ color: "#0099ff" }}
                        />
                        {quoteData.attachment ? (
                          <a
                            href={`${imageURL}${quoteData.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#0099ff",
                              textDecoration: "underline",
                            }}
                          >
                            {quoteData.attachment.split("/").pop()}
                          </a>
                        ) : (
                          "No attachment"
                        )}
                      </p>
                    </div>
                  </Col>
                </Row>

                <hr />
              </div>

              <p style={{ height: "5rem" }}>
                <div style={{ marginBottom: "20px", height: "15%" }}>
                  <div className="alert alert-warning mb-5">
                    <div className="d-flex" style={{ gap: "10px" }}>
                      <div>
                        <i
                          className="bi bi-info-circle"
                          style={{ fontSize: "25px" }}
                        ></i>
                      </div>

                      <div>
                        <p>
                          Customize your settings and form fields from Setting
                          ---&gt; Preference
                        </p>
                        <p></p>
                        <p>
                          Choose your Customize Quotation format from Setting
                          ---&gt; Masters --&gt; Templates
                        </p>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </p>

              <p style={{ height: "8rem" }}></p>

              {location?.state?.key2 && (
                <>
                  <div
                    className="bg-white position-sticky "
                    style={{
                      // paddingRight: "17px",
                      // height: 75,
                      // bottom: "1.5px",
                      // right: "20.5px",
                      // display: "flex",
                      // alignItems: "center",
                      // justifyContent: "end",
                      // width: "93.4%",
                      // zIndex: 11,
                      // borderTop: "1px solid lightblue",
                      paddingTop: "13px",
                      paddingBottom: "15px",
                      paddingRight: "17px",
                      // height: 75,
                      bottom: "67.5px",
                      // right: "20.5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                      // width: "93.4%",
                      zIndex: 11,
                      borderTop: "1px solid lightblue",

                    }}
                  >
                    <Button
                      className="btn btn-default-outline me-2"
                      onClick={handleCloseQuotationDetails}
                    >
                      Cancel
                    </Button>

                    <Button
                      className={`${location?.state?.key2
                        ? "btn btn-danger me-2"
                        : "btn btn-primary me-2"
                        }`}
                      onClick={() => handleOpenModal("reject")}
                    >
                      {location?.state?.key2 ? "Reject" : ""}
                    </Button>

                    <Button
                      className="btn btn-default"
                      onClick={() => handleOpenModal("approve")}
                    >
                      {location?.state?.key2 ? "Approve" : ""}
                    </Button>

                    <Modal show={showModal} onHide={handleCloseModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {modalType === "reject"
                            ? "Confirm Rejection"
                            : "Confirm Approval"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {modalType === "reject" ? (
                          <>
                            <p>
                              Are you sure you want to reject the quotation?
                            </p>
                            <Form.Group controlId="rejectReason">
                              <Form.Label>Reason</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                value={rejectReason}
                                onChange={(e) =>
                                  setRejectReason(e.target.value)
                                }
                              />
                            </Form.Group>
                          </>
                        ) : (
                          <p>Are you sure you want to approve the quotation?</p>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          className="btn btn-default-outline me-2"
                          onClick={handleCloseModal}
                        >
                          Cancel
                        </Button>
                        <Button
                          className="btn btn-default"
                          // variant={modalType === "reject" ? "danger" : "success"}
                          onClick={handleConfirm}
                          disabled={
                            loading || (modalType === "reject" && rejectReason.trim() === "")
                          }
                        >
                          {loading ? "Submiting.." : "Confirm"}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </>
              )}
              {showModalD && (
                <Modal show={showModalD} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Cancel Quotation</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <>
                      <p>Are you sure you want to cancel the quotation?</p>
                      <Form.Group controlId="rejectReason">
                        <Form.Label>Reason</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={rejectReason}
                          onChange={(e) => setRejectReason(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="btn btn-default-outline me-2"
                      onClick={handleCloseModa}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-default"
                      onClick={handleConfir}
                      disabled={rejectReason.trim() === ""}
                    >
                      {loading ? "Submiting.." : "Confirm"}
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </Col >
          </Row >
        </div >
        {salesOrderDetailsOffcanvas && (
          <SalesOrderDetailsOffcanvas
            // isMyApproval={isMyApproval}
            isEditOpen={isEditOpen}
            setIsEditOpen={setIsEditOpen}
            isClone={isClone}
            // fetchSalesOrder={fetchSalesOrder}
            show={salesOrderDetailsOffcanvas}
            setShowSalesOrderDetails={setSalesOrderDetailsOffcanvas}
            salesDetails={editData}
            // handleCloneClick={handleCloneClick}
            handleClose={() => setSalesOrderDetailsOffcanvas(false)}
          />
        )
        }
      </div >

      <style jsx>{`
        // .sales-order-accordion .accordion-button:not(.collapsed) {
        //   // background-color: var(--bs-accordion-active-bg);
        //   box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0
        //     var(--bs-accordion-border-color);
        //   color: var(--bs-accordion-active-color);
        // }

        .sales-order-accordion .accordion-button:focus {
          border-color: var(--primary03);
          box-shadow: none;
        }

        .sales-order-accordion .accordion-button::after {
          font-family: remixicon !important;
          font-size: 0.8rem;
          line-height: 1;
          background-color: transparent !important;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3.125rem;
          color: var(--default-text-color);
        }

        .sales-order-accordion .accordion-button {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          padding: var(--bs-accordion-btn-padding-y)
            var(--bs-accordion-btn-padding-x);
          font-size: 1rem;
          color: var(--bs-accordion-btn-color);
          text-align: left;
          // background-color: #fff3cd; 
          border: 0;
          overflow-anchor: none;
          transition: var(--bs-accordion-transition);
        }

        .table-sticky thead th {
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 10;
        }
      `}</style>
    </>
  )
}

const styles = {
  valuesStyle: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyle1: {
    marginBottom: 0,
    paddingTop: 25,
    paddingLeft: 13,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 500,
    color: "black",
    cursor: "pointer",
  },
}